import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './disclaimer.css';
import Nav from '../../components/Nav/Nav';
import Button from '../../components/Button/Button';
import ColoredBar from '../../components/ColoredBar/ColoredBar';
import MetricsContext from '../../context/MetricsContext';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';

export default function Disclaimer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateUserMetric } = useContext(MetricsContext);
  const startDate = new Date();
  const sessionId = localStorage.getItem('sessionId');
  const VERSION_STORAGE_KEY = '@kitoApp/version';
  const [, setActiveVersion] = useState(() => window.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult');

  useEffect(() => {
    updateUserMetric({
      name: PageNames.DISCLAIMER_PAGE,
      pageType: PageTypes.DEFAULT,
    });
  }, [sessionId]);

  const updateMetrics = (btn) => {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.DISCLAIMER_PAGE,
      pageType: PageTypes.DEFAULT,
      duration: Math.abs(dateFinal - startDate),
      interactions: [
        {
          name: btn,
          time: dateFinal,
        },
      ],
    });
  };

  const redirectUser = () => {
    updateMetrics('Go back');
    navigate('/agreement');
  };

  return (
    <div className="container">
      <Nav goBack logo={false} label="" sidebar onVersionChange={setActiveVersion} />
      <ColoredBar />
      <div className="containerContent disclaimer__page">
        <p>{t('disclaimerpage.paragraph1')}</p>
        <br />
        <p>{t('disclaimerpage.paragraph2')}</p>
        <br />
        <p>{t('disclaimerpage.paragraph3')}</p>
        <div className="disclaimer__bottomwrapper">
          <Button width="fullWidth" additionalClass="outline" onClick={redirectUser}>
            {t('disclaimerpage.button2')}
          </Button>
        </div>
      </div>
    </div>
  );
}
